import Vue from 'vue'
//import VueX from 'vuex'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import i18n from './i18n'

import store from './store'
import router from './config/PageRouter'

// plugins
import moment from 'moment'
import VueDateTimePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import VueApexCharts from 'vue-apexcharts';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

// fa icons
import '@fortawesome/fontawesome-free/css/all.css'

import App from './App.vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueDateTimePicker)
Vue.prototype.$moment = moment
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('vSelect', vSelect)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
